export const airConditioningAndVentilationInspectionCases = [
  {
    section: '1',
    title: 'בדיקת תכנון/התקנה',
    isTitle: true,
    subCases: [
      {
        section: '1.1',
        title: 'התקבלו תוכניות בטיחות מאושרות ע"י רשות כבאות והצלה',
        isTitle: false
      },
      {
        section: '1.2',
        title:
          'התקבלו תוכניות מיזוג אוויר מפורטות כולל חתכים ומידות בקנה מידה, במידת הצורך',
        isTitle: false
      },
      {
        section: '1.3',
        title: 'ע"ג התוכניות מסומנים מדפי אש בכל מעבר של קיר אש',
        isTitle: false
      },
      {
        section: '1.4',
        title: 'ע"ג התוכניות מסומנים מדפי עשן, מדפים משולבים בתאם לדרישות התקן',
        isTitle: false
      },
      {
        section: '1.5',
        title: 'ע"ג התוכניות מסומנות יניקות עשן בהתאם למצוין בתוכנית הבטיחות',
        isTitle: false
      },
      {
        section: '1.6',
        title:
          'כל תעלות פינוי עשן בנויות בעובי דופן של 1.25 מ"מ לפחות בהתאם לתקנות חוק תכנון ובניה',
        isTitle: false
      },
      {
        section: '1.7',
        title:
          'ע"ג התוכניות מסומן תוואי תעלות פינוי עשן עם סגירות / עטיפות 120 דקות, בהתאם למצוין בתוכניות הבטיחות',
        isTitle: false
      },
      {
        section: '1.8',
        title:
          'תחולה למפרע. \nתנאי תקן זה אינם מיועדים לחול למפרע. כאשר מערכת עוברת שינוי, הרחבה או חידוש יחולו דרישות תקן זה על העבודה החדשה המבוצעת בלבד',
        isTitle: false
      },
      {
        section: '1.9',
        title: 'מסמכים ואישורים על בסיסם בוצע הבדיקה',
        isTitle: true
      },
      {
        section: '1.9.1',
        title:
          'הצהרת ואישור מתכן מיזוג אוויר לציוד וחומרים בפרויקט ע"פ ת"י 1001',
        isTitle: false
      },
      {
        section: '1.9.2',
        title:
          'הצהרת ואישור קבלן מיזוג אוויר לציוד וחומרים בפרויקט ע"פ ת"י 1001',
        isTitle: false
      },
      {
        section: '1.9.3',
        title:
          'בדיקות ואישורים ע"פ 755 לחומרי המיזוג הנלווים כגון: בידוד תעלות, תעלות גמישות, עיפות קרמיות, וכל חומר אחר של מערכת מיזוג האוויר.',
        isTitle: false
      },
      {
        section: '1.9.4',
        title: 'אישור בודק חשמל ללוחות המיזוג, המפוחים בפרויקט',
        isTitle: false
      },
      {
        section: '1.9.5',
        title: 'תעודות בדיקה למפוחי פינוי עשן ע"פ ת"י 1001 חלק 7',
        isTitle: false
      },
      {
        section: '1.9.6',
        title: 'משטר הפעלות מערכות בטיחות אש ע"פ הוראות מכ"ר 536',
        isTitle: false
      },
      {
        section: '1.9.7',
        title: 'תעודת בדיקה למערכת גילוי האש ע"פ ת"י 1220 חלק 3',
        isTitle: false
      }
    ]
  },
  {
    section: '4',
    title: 'מערכות חימום, אוורור ומיזוג אוויר (HVAC Systems)',
    isTitle: true,
    subCases: [
      {
        section: '4.1',
        title: 'דרישות ציוד כלליות',
        isTitle: true
      },
      {
        section: '4.1.1',
        title:
          'גישה:\nעל הציוד להיות מותקן באופן המאפשר גישה לביקורת, לתחזוקה ולתיקונים.',
        isTitle: false
      },
      {
        section: '4.1.2',
        title:
          'בחירת והתקנת הציוד ייעשו בהתאם ליישום על פי הוראות ההתקנה/הרישום של היצרן.',
        isTitle: false
      },
      {
        section: '4.1.3.2',
        title: 'על הציוד להיות ממוגן מפני חדירת גופים זרים לתוך המערכת.',
        isTitle: false
      },
      {
        section: '4.2',
        title: 'רכיבי מערכת',
        isTitle: true
      },
      {
        section: '4.2.1.1',
        title:
          'הגנת כניסות האוויר החיצוני תיעשה באמצעות רשתות מחומר עמיד בשיתוך (קורוזיה) בעלות חורים הקטנים מ-12.7 מ"מ.',
        isTitle: false
      },
      {
        section: '4.2.1.2',
        title:
          'יש למקם את כניסות האוויר החיצוני באופן הממזער את חדירת האש או העשן לתוך הבניין.',
        isTitle: false
      },
      {
        section: '4.2.1.2.1',
        title:
          'כאשר מיקום כניסות האוויר החיצוני אינו עומד בדרישות סעיף 4.2.1.2, יש לציידן במדף אש המתאים  לתקן הישראלי ת"י 1001 חלק 3 או/וגם מדף עשן המתאים לתקן הישראלי ת"י 1001 חלק 4. (ראה פרק 6.3 להפעלת מדף עשן כדי להגביל את חדירת העשן.)',
        isTitle: false
      },
      {
        section: '4.2.2.1',
        title:
          'מסנני אוויר המותקנים בתקרת תותב יהיו עשויים חומרים שסיווג האש שלהם אינו קטן מסיווג האש של החומרים שמהם עשויה תקרת התותב, לפי התקן הישראלי ת"י 921',
        isTitle: false
      },
      {
        section: '4.2.3',
        title: 'מאווררים',
        isTitle: true
      },
      {
        section: '4.2.3.1.1',
        title: 'המפוחים יותקנו בהתאם לתפקודם הנדרש ולפי הוראות יצרן המפוח.',
        isTitle: false
      },
      {
        section: '4.2.3.1.2',
        title: 'על המאווררים להיות מאושרים להתקנה הספציפית.',
        isTitle: false
      },
      {
        section: '4.2.3.2',
        title:
          'גישה:\nיש למקם את המאווררים, לסדרם ולהתקינם באופן המאפשר גישה לצורכי ביקורת ותחזוקה.',
        isTitle: false
      },
      {
        section: '4.2.3.3',
        title:
          'פתחי כניסה חשופים:\n יש להגן על פתחי כניסה חשופים של המאוורר ע"י רשת מתכת ע"מ למנוע חדירת נייר, פסולת וגופים זרים.',
        isTitle: false
      },
      {
        section: '4.2.4',
        title: 'ציוד קירור וחימום אוויר',
        isTitle: true
      },
      {
        section: '4.2.4.1.1',
        title:
          'הציוד לחימום וקירור יותקן בהתאם לתפקודו הנדרש ולפי הוראות יצרן הציוד.',
        isTitle: false
      },
      {
        section: '4.2.4.2',
        title:
          'חומרים:\nעל החומרים המשמשים לייצור יחידות סלילי חימום/קירור, יחידות מיזוג אוויר אוטונומיות, כבשנים, משאבות חום, מתקני לחלוח וכל ציוד דומה, לעמוד בדרישות סעיף 4.3.3.1 אלא אם נקוב אחרת בסעיפים 4.2.4.2.1 או 4.2.4.2.2.',
        isTitle: false
      },
      {
        section: '4.2.4.5.1',
        title:
          'כאשר מתקני חימום המופעלים בהתנגדות חשמלית או בשריפת דלק מותקנים בתעלות אוויר, על מעטפתי תעלות האוויר ועל התקנתם לעמוד בהוראות סעיף 4.3.5.3.',
        isTitle: false
      },
      {
        section: '4.3',
        title: 'חלוקת אוויר',
        isTitle: true
      },
      {
        section: '4.3.1',
        title: 'תעלות אוויר',
        isTitle: true
      },
      {
        section: '4.3.1.1',
        title:
          'מובלי אוויר ייבנו מחומרים בעלי סיווג אש Class A1, ובתנאי שעומדים בכל דרישות תקן זה.',
        isTitle: false
      },
      {
        section: '4.3.1.2',
        title:
          'תעלות אוויר קשיחות או גמישות מסיווג Class 0 או Class 1 שנבדקו בהתאם ל - ת"י 5678 - אוורור בנינים - מובלים - מידות ודרישות מכניות למובלים גמישים, המותקנים בהתאם לתנאי הרישום, יהיו מותרות לשימוש כתעלות בהם טמפרטורת האוויר בתעלות אינה עולה על 121°C (250 ° F) או כאשר משמשים כתעלה אנכית המשרתת לא יותר משני קומות סמוכות בגובה.\nומובלים קשיחים שסווגו כבעלי דרגת סיווג אש שאינה קטנה מ- ,Class B דרגת צפיפות עשן S1 ודרגת טפטוף ."d',
        isTitle: false
      },
      {
        section: '4.3.1.3.1',
        title:
          'מותר להשתמש בלוחות גבס בעלי סיווג אש Class B ודרגת צפיפות עשן S1, לבניית מובלים להוצאת אוויר בלחץ שלילי ולבניית מובלים לאוויר חוזר, אם טמפרטורת האוויר במובל אינה גדולה מ- 52°C צלזיוס בתנאי שירות רגילים.',
        isTitle: false
      },
      {
        section: '4.3.1.3.2',
        title:
          'מגבלת טמפרטורת האוויר הנקובה בסעיף 4.3.1.3.1 אינה חלה כאשר לוחות הגבס משמשים כתעלות אוויר לפליטת עשן במצבי חירום.',
        isTitle: false
      },
      {
        section: '4.3.1.4',
        title:
          'על כל החומרים המשמשים לבניית תעלות אוויר להיות מתאימים לחשיפה מתמשכת לתנאי הטמפרטורה והלחות של האוויר הממוזג העובר דרכן.',
        isTitle: false
      },
      {
        section: '4.3.1.8',
        title:
          'תעלות גמישות מבד \nמערכות פיזור האוויר יעמדו בקריטריונים הבאים:\n(1) הם יותקנו רק במקומות חשופים לחלוטין.\n(2) הם יפעלו תמיד תחת לחץ חיובי.\n(3) הם לא יחדרו רכיבי מבנה בעלי עמידות באש (קירות אש וכו\').\n(4) הם לא יעברו דרך רכיבי מבנה בעלי עמידות באש .\n(5) הם יתאימו ויתויגו בהתאם ל- UL 2518\nהמערכות יעמדו בדרישות התקן הישראלי ת"י 755, ויבנו מחומרים בעלי סיווג אש Class B ודרגת צפיפות עשן S2.',
        isTitle: false
      },
      {
        section: '4.3.2',
        title: 'מחברי אוויר (מחברים גמישים)',
        isTitle: true
      },
      {
        section: '4.3.2.1.1',
        title:
          'מחברי האוויר יהיו תואמים לדרישות Class 0 או Class 1 כאשר הם נבדקים בהתאם ל - ת"י 5678 - אוורור בנינים - מובלים - מידות ודרישות מכניות למובלים גמישים המיוצרים במפעל.',
        isTitle: false
      },
      {
        section: '4.3.2.1.2',
        title:
          'מחברי אויר מסוג Class 0 או Class 1 לא ישמשו לתעלות המכילות אוויר בטמפרטורה העולה על 121°C (250°F).',
        isTitle: false
      },
      {
        section: '4.3.2.1.3',
        title: 'אסור שאורך מחבר אוויר יעלה על 4.27 מטר (14 רגל).',
        isTitle: false
      },
      {
        section: '4.3.2.1.4',
        title:
          'אין להעביר מחברי אוויר (מחברים גמישים) דרך קיר, מחיצה או מעטפת של פיר אנכי הנדרשים לדרגת עמידות באש במשך שעה אחת או יותר.',
        isTitle: false
      },
      {
        section: '4.3.2.1.5',
        title: 'אין להעביר מחברי אוויר (מחברים גמישים) דרך רצפה.',
        isTitle: false
      },
      {
        section: '4.3.2.2',
        title:
          'מבדדי רעידות גמישים יהיו עשויים חומרים שסיווג האש שלהם אינו קטן מ-  Class B ודרגת צפיפות העשן שלו S1.',
        isTitle: false
      },
      {
        section: '4.3.2.3',
        title: 'אין להתקין חיווט במחברי האוויר.',
        isTitle: false
      },
      {
        section: '4.3.3',
        title: 'חומרים משלימים למערכות חלוקת אוויר',
        isTitle: true
      },
      {
        section: '4.3.3.1',
        title:
          'חומר בידוד פנימי, חומר בידוד חיצוני, חומרי הדבקה, מחסום אדים, סרטי חיזוק ומשתיקי קול יהיו בעלי סיווג אש שאינו קטן מ - Class B ודרגת צפיפות עשן S1.\nחומר בידוד או כיסוי של צנרת המותקנת בתוך תא אוויר יהיו בעלי סיווג אש שאינו קטן מ - Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.3.1.1',
        title:
          'אם בידוד המובל מודבק בחומרי הדבקה, ייבדק סיווג האש של הבידוד יחד עם חומרי ההדבקה. דרישה זו אינה חלה על בידוד חיצוני הנמצא כולו מחוץ למבנה ואינו חודש דרך קיר או גג.',
        isTitle: false
      },
      {
        section: '4.3.3.1.2',
        title: 'גלאי עשן הנדרשים על פי סעיף 6.4.4 אינם נדרשים בסיווג אש',
        isTitle: false
      },
      {
        section: '4.3.3.4',
        title:
          'אין להעביר כיסויי תעלות אוויר הנדרשים לעצירת אש או לדרגת עמידות באש דרך קירות או רצפות אלא אם כיסויים אלה עומדים בדרישות ת"י 1212.',
        isTitle: false
      },
      {
        section: '4.3.3.5',
        title:
          'אין להתקין ציפויי תעלות אוויר פנימיים ליד מדפי אש כדי למנוע הפרעה לפעולת מדפים (Dumper) אלה.',
        isTitle: false
      },
      {
        section: '4.3.3.6',
        title:
          'אין להתקין מעטפתי תעלות אוויר באופן המסתיר את פתחי השירות או מונע את השימוש בהם.',
        isTitle: false
      },
      {
        section: '4.3.4',
        title: 'חומרים להפעלה ובקרה של מערכת חלוקת האוויר',
        isTitle: true
      },
      {
        section: '4.3.4.1',
        title:
          'אין להתקין חיווט בתעלות האוויר, למעט כפי שהותר בשלושת סעיפים אלו:',
        isTitle: false
      },
      {
        section: '4.3.4.2',
        title:
          '1.  מותר להתקין חיווט בתעלות אוויר רק אם החיווט שייך ישירות למערכת חלוקת האוויר ואינו עולה על 1.22 מטר.',
        isTitle: false
      },
      {
        section: '4.3.4.3',
        title:
          '2.  החיווט המותר בסעיף 4.3.4.2 יהיה קצר ככל האפשר מבחינה מעשית.',
        isTitle: false
      },
      {
        section: '4.3.4.4',
        title:
          '3.  כאשר ייבדקו על פי תקן הבדיקות NFPA 262, חוטים וכבלים חשמליים וכבלי סיבים אופטיים יהיו מורכבים מחוטים או כבלים המפורטים כבעלי צפיפות שיא אופטית מרבית של 0.50 או פחות, צפיפות אופטית ממוצעת של 0.15 או פחות, ומרחק התפשטות להבה מרבי של 1.5 מטר או פחות, או יותקנו במסילות חיווט מתכתיות ללא מעטפת אל-מתכתי כולל או כבל מצופה מתכת ללא מעטפת אל-מתכתי כולל.',
        isTitle: false
      },
      {
        section: '4.3.4.5',
        title:
          'כדי להתחבר לציוד, צינורות פנאומטיים אל-מתכתיים למערכות בקרה יורשו להכיל עד 457.2 מ"מ של צינור העומד בדרישות סעיף 4.3.11.2.6.2.',
        isTitle: false
      },
      {
        section: '4.3.5',
        title: 'גישה לתעלות אוויר וביקורת',
        isTitle: true
      },
      {
        section: '4.3.5.1',
        title:
          'יש להתקין פתח שירות בתעלות אוויר סמוך לכל מדף אש, מדף עשן, מדף אש/ עשן משולב וגלאי עשן.',
        isTitle: false
      },
      {
        section: '4.3.5.1.1',
        title: 'הפתח חייב להיות גדול דיו כדי לאפשר את תחזוקת המתקנים ואיפוסם.',
        isTitle: false
      },
      {
        section: '4.3.5.3',
        title:
          'בתעלות אוויר ובתאי קיבול (פלנום) אופקיים יש להתקין פתחי שירות כדי להקל על הסרת האבק וחומרי הבעירה שמצטברים.',
        isTitle: false
      },
      {
        section: '4.3.5.3.1',
        title:
          'יש למקם את פתחי השירות במרחקים של כ-6.1 מטר זה מזה לאורך תעלת האוויר ובבסיס כל קטע אנכי - אלא אם מאושר אחרת בסעיפים 4.3.5.3.2 עד 4.3.5.3.4.',
        isTitle: false
      },
      {
        section: '4.3.5.3.2',
        title:
          'ניתן לשים פתחי יציאת/כניסת אוויר הניתנים להסרה ובגודל מתאים, במקום פתחי השירות.',
        isTitle: false
      },
      {
        section: '4.3.5.3.3',
        title:
          'פתחי שירות אינם נדרשים בתעלות אוויר המספקות אוויר שעבר קודם לכן דרך מסנן אוויר, מתקן לניקוי אוויר, או ריסוס מים.',
        isTitle: false
      },
      {
        section: '4.3.5.3.4',
        title:
          "פתחי שירות אינם נדרשים כאשר מתמלאים כלל התנאים הבאים:\n(1)  המקום הממוזג אינו מכיל תהליכים המפיקים חומר בעיר כמו אבק, מוך או אדים שומניים. דוגמת בנקים, בנייני משרדים, בתי כנסת, בתי מלון ומוסדות בריאות (אך לא מטבחים, מכבסות וחלקים יצרניים של מוסדות כאלה).\n(2)  כניסות האוויר ממוקמות לפחות 2.13 מטר מעל הרצפה או שהן מוגנות ברשתות בעלות עינה 14 [1.8 מ\"מ], העשויות מתכת עמידה בשיתוך. באופן זה נמנעת סחיפת ניירות, פסולת או מוצקים בעירים אחרים לתוך תעלת האוויר המחזירה.\n(3)  המהירות המתוכננת המזערית בתעלת האוויר המחזירה לאזור המאוכלס היא 5.08 מ'/שנ'.",
        isTitle: false
      },
      {
        section: '4.3.5.4',
        title:
          'מותר להתקין חלונות ביקורת בתעלות אוויר, ובלבד שהם סגורים בזכוכית מזוינת או בזכוכית חסינת אש.',
        isTitle: false
      },
      {
        section: '4.3.5.5',
        title:
          'יש להתקין פתחים בקירות או בתקרות כדי לאפשר גישה לפתחי השירות בתעלות האוויר לצורכי תחזוקה וביקורת.',
        isTitle: false
      },
      {
        section: '4.3.5.6',
        title:
          'כאשר נדרש פתח שירות בתעלת אוויר הממוקמת מעל תקרה של מכלל רצפה-תקרה או גג-תקרה שנבדק ונקבעה לו דרגת עמידות באש על פי ת"י 931 חלק 1 (על חלקי המשנה שלו) - עמידות אש של אלמנטי בניין - שיטות בדיקה, חובה למקם את פתח הגישה בתקרה.',
        isTitle: false
      },
      {
        section: '4.3.5.7',
        title:
          'יש לתכנן את פתח השירות ולהתקינו באופן שאינו פוגע בדרגת העמידות באש של המכלל.',
        isTitle: false
      },
      {
        section: '4.3.6',
        title: 'שלמות תעלות האוויר',
        isTitle: true
      },
      {
        section: '4.3.6.1',
        title:
          'תעלות האוויר יהיו ממקומות במקום שבו לא יהיו חשופות לנזק או לשבר, או שימוגנו ע"מ לשמור על שלמותן.',
        isTitle: false
      },
      {
        section: '4.3.6.2',
        title:
          'כאשר תעלת אוויר ממוקמת מחוץ לבניין, יש להגן עליה ועל המעטפת או הציפוי פנימי שלה, מפני גורמים מזיקים.',
        isTitle: false
      },
      {
        section: '4.3.7',
        title: 'פתחי יציאת אוויר',
        isTitle: true
      },
      {
        section: '4.3.7.1',
        title:
          'כללי. \nאסור שאוויר המסופק לחלל כלשהו יכיל אדים דליקים, פריטים מעופפים או אבק בכמות ובריכוז העלולים ליצור תנאים מסוכנים.',
        isTitle: false
      },
      {
        section: '4.3.7.2',
        title:
          'מבנה פתחי יציאת אוויר\nיציאות האוויר ייבנו מחומרים בעלי סיווג אש שאינו קטן מ - Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.7.3.1',
        title:
          'יש למקם את פתחי יציאת האוויר לפחות 76 מ"מ מעל הרצפה אלא אם הותקנו אמצעים המונעים חדירת לכלוך ואבק והצטברותם בתוך המערכת.',
        isTitle: false
      },
      {
        section: '4.3.7.3.2',
        title:
          'כאשר פתחי יציאת האוויר ממוקמים בגובה הנמוך מ-2.13 מטר מעל הרצפה, יש להגן עליהם על ידי סורג או רשת, ואסור שפתחי הסורג או הרשת יאפשרו מעבר של כדור בקוטר 12.7 מ"מ.',
        isTitle: false
      },
      {
        section: '4.3.8',
        title: 'פתחי כניסת אוויר – חזרה או פליטה או חזרה ופליטה',
        isTitle: true
      },
      {
        section: '4.3.8.1',
        title:
          'כללי\nאין למחזר אוויר מכל חלל שבו אדים דליקים, פריטים מעופפים או אבק נישאים בכמות ובריכוזים העלולים ליצור תנאים מסוכנים במערכת החזרת האוויר.',
        isTitle: false
      },
      {
        section: '4.3.8.2',
        title:
          'מבנה פתחי כניסת אוויר\nכניסות האוויר ייבנו מחומרים בעלי סיווג אש שאינו קטן מ - Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.8.3.1',
        title:
          'יש למקם את פתחי כניסת האוויר לפחות 76 מ"מ מעל הרצפה אלא אם הותקנו אמצעים המונעים חדירת לכלוך ואבק והצטברותם בתוך המערכת.',
        isTitle: false
      },
      {
        section: '4.3.8.3.2',
        title:
          'כאשר פתחי כניסת האוויר ממוקמים בגובה הנמוך מ-2.13 מטר מעל הרצפה, יש להגן עליהם על ידי סורג או רשת, ואסור שפתחי הסורג או הרשת יאפשרו מעבר של כדור בקוטר 12.7 מ"מ.',
        isTitle: false
      },
      {
        section: '4.3.9',
        title: 'מדפי אש',
        isTitle: true
      },
      {
        section: '4.3.9.1',
        title:
          'מדפי אש המתאימים לתקן הישראלי ת"י 1001 חלק 3 יסופקו בהתאם לנדרש בפרק 5.',
        isTitle: false
      },
      {
        section: '4.3.9.2',
        title: 'מדפי אש יותקנו בהתאם לייעודם ולפי הוראות היצרן.',
        isTitle: false
      },
      {
        section: '4.3.10',
        title: 'מדפי עשן',
        isTitle: true
      },
      {
        section: '4.3.10.1',
        title:
          'מדפי עשן המתאימים לתקן הישראלי ת"י 1001 חלק 4 יסופקו בהתאם לנדרש בפרק 5.',
        isTitle: false
      },
      {
        section: '4.3.10.1.1',
        title: 'מדפי עשן יותקנו בהתאם לייעודם ולפי הוראות היצרן.',
        isTitle: false
      },
      {
        section: '4.3.10.2',
        title:
          'יש להתקין את מדפי העשן במערכות בעלות תפוקה העולה על 15,000 CFM כדי לבודד את הציוד לשינוע האוויר, כולל מסננים, מיתר חלקי המערכת הן מצד האספקה לבניין והן מצד ההחזרה, ולהגביל את מחזור העשן – אלא אם מתקיים מצב ספציפי כמפורט בסעיפים 4.3.10.2.1 או 4.3.10.2.2 להלן:',
        isTitle: false
      },
      {
        section: '4.3.10.2.1',
        title:
          'יחידות המשנעות אוויר הממוקמות בקומה שרק אותה הן משרתות פטורות מדרישות 4.3.10.2.',
        isTitle: false
      },
      {
        section: '4.3.10.2.2',
        title:
          'יחידות משנעות אוויר הממוקמות על הגג ומשרתות רק את הקומה שמתחת לגג פטורות מדרישות 4.3.10.2.',
        isTitle: false
      },
      {
        section: '4.3.11',
        title: 'תאי קיבול (פלנום)',
        isTitle: true
      },
      {
        section: '4.3.11.1',
        title: 'אחסון',
        isTitle: true
      },
      {
        section: '4.3.11.1.1',
        title: 'אין להשתמש בתאי קיבול (פלנום) לתפוסה או לאחסון.',
        isTitle: false
      },
      {
        section: '4.3.11.1.2',
        title:
          'חומר נטוש אך נגיש ייחשב כמאוחסן ויש להרחיקו. כאשר מזוהים כבלים לשימוש עתידי באמצעות תג, התג יהיה בעל עמידות מספיקה כדי לעמוד בתנאי הסביבה המדוברת.',
        isTitle: false
      },
      {
        section: '4.3.11.2',
        title: 'תא קיבול (פלנום) בחלל התקרה',
        isTitle: true
      },
      {
        section: '4.3.11.2.2',
        title:
          "מפזרי אור שאינם עשויים ממתכת או מזכוכית, המשמשים במתקן תאורה משולב עם מפזר אוויר, יהיו מפורטים ומסומנים 'מפזרי אור למתקני שינוע אוויר' ('Fixture Light Diffusers for Air Handling Fixtures').",
        isTitle: false
      },
      {
        section: '4.3.11.2.3',
        title:
          'אסור שטמפרטורת האוויר המסופק לתאי קיבול (פלנום) אלה תעלה על 121ºC.',
        isTitle: false
      },
      {
        section: '4.3.11.2.4',
        title:
          'החומרים המשמשים במבנה של תאי הקיבול (פלנום) בתקרה חייבים להיות לא בעירים או בעלי בעירות מוגבלת ומדד התפתחות עשן של 50',
        isTitle: false
      },
      {
        section: '4.3.11.2.4.1',
        title:
          'חומרים המשמשים במבנה של חלל תא הקיבול (פלנום) בין התקרה לגג (או לרצפה), שאינם נמנים על מכללים עמידים באש הנדונים בסעיף 5.3.3, מותרים על פי המפורט בסעיפים 4.3.11.2.4.2 ו-4.3.11.2.4.3.',
        isTitle: false
      },
      {
        section: '4.3.11.2.4.2',
        title:
          'חומרי התקרה יהיו בעלי סיווג אש שאינו קטן מ - Class B ודרגת צפיפות עשן S1. כל המשטחים, כולל אלה שיחשפו  על ידי חיתוך דרך החומר בכל דרך, חייבים לעמוד בדרישות אלה.',
        isTitle: false
      },
      {
        section: '4.3.11.2.4.3',
        title: 'תמיכות התקרה חייבות להיות עשויות מחומרים לא בעירים.',
        isTitle: false
      },
      {
        section: '4.3.11.2.5',
        title:
          'כאשר תא הקיבול (פלנום) הוא חלק ממכלל רצפה-תקרה או גג-תקרה שנבדק ונחקר ונקבעה לו דרגת עמידות באש של שעה אחת או יותר, על המכלל לעמוד בדרישות סעיף 5.3.3.',
        isTitle: false
      },
      {
        section: '4.3.11.2.6',
        title:
          'חומרים הנמצאים בחלל תא הקיבול (פלנום) והחשופים לזרם האוויר חייבים להיות לא בעירים או לעמוד בדרישות סעיפים 4.3.11.2.6.1 עד 4.3.11.2.6.10, על פי העניין:',
        isTitle: false
      },
      {
        section: '4.3.11.2.6.1',
        title:
          'בבדיקה על פי תקן NFPA 262, חוטים וכבלים חשמליים וכבלי סיבים אופטיים יימצאו כבעלי צפיפות שיא אופטית מרבית של 0.50 או פחות, צפיפות אופטית ממוצעת של 0.15 או פחות, ומרחק התפשטות להבה מרבי של 1.5 מטר או פחות, או יותקנו במסילות חיווט מתכתיות ללא מעטפת אל-מתכתי כולל, כבל מצופה מתכת ללא מעטפת אל-מתכתי כולל או תעלות פסי צבירה מתכתיות סגורות לחלוטין שאינן מאווררות ללא מעטפת אל-מתכתי כולל.',
        isTitle: false
      },
      {
        section: '4.3.11.2.6.6',
        title:
          'צינורות וצנרת פלסטיק המשמשים במערכות אינסטלציה יותרו לשימוש בתוך פלנום בחלל התקרה אם יהיו עשויים חומרים בעלי סיווג אש שאינו קטן מ - Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.11.2.6.7',
        title:
          'חומרים משלימים למערכות חלוקת אוויר מותרים לשימוש בתנאי שהם עומדים בדרישות סעיף 4.3.3.',
        isTitle: false
      },
      {
        section: '4.3.11.2.6.8',
        title: 'גלאי עשן אינם נדרשים לעמוד בדרישות סעיף 4.3.',
        isTitle: false
      },
      {
        section: '4.3.11.2.6.9',
        title:
          'תעלות אוויר העומדות בדרישות סעיף 4.3.1.2 ומחברי אוויר (מחברים גמישים) העומדים בדרישות סעיף 4.3.2 מותרים לשימוש.',
        isTitle: false
      },
      {
        section: '4.3.11.2.7',
        title: 'יש לסלק את חלקם הנגיש של החומרים הנטושים החשופים לזרם האוויר.',
        isTitle: false
      },
      {
        section: '4.3.11.3',
        title: 'תא קיבול (פלנום) ומעטפת של מתקן',
        isTitle: true
      },
      {
        section: '4.3.11.3.1',
        title:
          'מותר להשתמש בתא קיבול (פלנום) ובמעטפת מתקן מיוצרים לשירותי הספקה/החזרה/פליטה של אוויר.',
        isTitle: false
      },
      {
        section: '4.3.11.3.2',
        title:
          'החומרים והמוצרים המשמשים תיבת מגן (casing) לציוד ולתאי אוויר המיוצרים מראש יתאימו לנדרש בסעיפים 4.3.1 ו- 4.3.3.',
        isTitle: false
      },
      {
        section: '4.3.11.3.3',
        title:
          'חוטים וכבלים חשמליים וכבלי סיבים אופטיים יעמדו בדרישות סעיף 4.3.4.',
        isTitle: false
      },
      {
        section: '4.3.11.4',
        title: 'תא קיבול (פלנום) של חדר יחידת שינוע האוויר',
        isTitle: true
      },
      {
        section: '4.3.11.4.1',
        title:
          'חדרים בודדים המאכלסים יחידה(ות) לשינוע אוויר יאספו אוויר חוזר ממקורות שונים וישלבו את האוויר בתוך החדר לפני החזרתו ליחידת שינוע האוויר.',
        isTitle: false
      },
      {
        section: '4.3.11.4.2',
        title:
          'מעטפתי תעלות האוויר, ציפויי תעלות פנימיים, ציפויים פנימיים/תאים אקוסטיים וחומרים שונים חייבים לעמוד בדרישות סעיף 4.3.3.',
        isTitle: false
      },
      {
        section: '4.3.11.4.3',
        title:
          'אין להשתמש בתא קיבול (פלנום) של חדר יחידת שינוע אוויר לאחסון או תפוסה אלא בשעת טיפול בציוד.',
        isTitle: false
      },
      {
        section: '4.3.11.4.4',
        title:
          'חומר נטוש אך נגיש ייחשב כמאוחסן ויש להרחיקו. כאשר מזוהים כבלים לשימוש עתידי באמצעות תג, התג יהיה בעל עמידות מספיקה כדי לעמוד בתנאי הסביבה המדוברת.',
        isTitle: false
      },
      {
        section: '4.3.11.4.5',
        title:
          'החומרים המשמשים במבנה של חדר יחידת שינוע אוויר חייבים להיות לא בעירים או בעלי בעירות מוגבלת (ראו הגדרה 3.3.21), ויהיו עמידים לחשיפה מתמדת לטמפרטורה וללחות של האוויר הממוזג העובר בתאי קיבול (פלנום) אלה.',
        isTitle: false
      },
      {
        section: '4.3.11.4.6',
        title:
          'בבדיקה על פי תקן NFPA 262, חוטים וכבלים חשמליים וכבלי סיבים אופטיים יהיו מפורטים כבעלי צפיפות שיא אופטית מרבית של 0.50 או פחות, צפיפות אופטית ממוצעת של 0.15 או פחות, ומרחק התפשטות להבה מרבי של 1.5 מטר או פחות, או יותקנו בתעלות חיווט מתכתיות, כבל מצופה מתכת או תעלות פסי צבירה סגורות לחלוטין שאינן מאווררות.',
        isTitle: false
      },
      {
        section: '4.3.11.5',
        title: 'תא קיבול (פלנום) מתחת לרצפה מורמת',
        isTitle: true
      },
      {
        section: '4.3.11.5.1',
        title:
          'החלל שבין החלק העליון של הרצפה המוגמרת לבין החלק התחתון של רצפה מורמת יכול לשמש להספקת אוויר לאזור המאוכלס או להחזרת האוויר לאותו אזור או לפליטת אוויר ממנו ובלבד שיתקיימו התנאים המפורטים בסעיפים 4.3.11.5.2 עד 4.3.11.5.6.',
        isTitle: false
      },
      {
        section: '4.3.11.5.2',
        title: 'נשמר כושר העצירה מפני חדירת אש.',
        isTitle: false
      },
      {
        section: '4.3.11.5.3',
        title:
          'אסור שטמפרטורת האוויר המסופק לתאי קיבול (פלנום) אלה תעלה על 121ºC.',
        isTitle: false
      },
      {
        section: '4.3.11.5.4',
        title:
          'החומרים המשמשים במבנה של תאי קיבול מתחת לרצפה מורמת חייבים להיות לא בעירים או בעלי בעירות מוגבלת, יהיו בעלי דרגת צפיפות עשן שאינה קטנה מ-3, ויהיו עמידים לחשיפה מתמדת לטמפרטורה וללחות של האוויר הממוזג העובר בתאי קיבול (פלנום) אלה.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5',
        title:
          'חומרים הנמצאים בתאי קיבול (פלנום) מתחת לרצפה מורמת והחשופים לזרם האוויר חייבים להיות לא בעירים או לעמוד בדרישות סעיפים 4.3.11.5.5.1 עד 4.3.11.5.5.11, על פי העניין.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5.1',
        title:
          'בבדיקה על פי תקן NFPA 262, חוטים וכבלים חשמליים וכבלי סיבים אופטיים יימצאו כבעלי צפיפות שיא אופטית מרבית של 0.50 או פחות, צפיפות אופטית ממוצעת של 0.15 או פחות, ומרחק התפשטות להבה מרבי של 1.5 מטר או פחות, או יותקנו בתעלות חיווט מתכתיות, כבל מצופה מתכת או תעלות פסי צבירה סגורות לחלוטין שאינן מאווררות.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5.5',
        title:
          'בחדרים למחשבים/לעיבוד נתונים, כאשר חדרים אלה מתוכננים ומותקנים בהתאם לתקן NFPA 75, מותרים רצפות מורמות, כבלים בין מכונות, חיווט חשמלי, סיבים אופטיים מפורטים בין תאי קיבול, מסילות אותות ותקשורת וכבלי סיבים אופטיים.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5.7',
        title:
          'צינורות וצנרת פלסטיק המשמשים במערכות אינסטלציה יותרו לשימוש בתוך פלנום של רצפה מורמת אם יהיו עשויים חומרים בעלי סיווג אש שאינו קטן מ- Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5.8',
        title:
          'תעלות אוויר העומדות בדרישות סעיף 4.3.1.2 ומחברי אוויר (מחברים גמישים) העומדים בדרישות סעיף 4.3.2 מותרים לשימוש.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5.10',
        title: 'גלאי עשן אינם נדרשים כדי לעמוד בדרישות סעיף 4.3.11.5.1.',
        isTitle: false
      },
      {
        section: '4.3.11.5.5.11',
        title:
          'חומרים משלימים למערכות חלוקת אוויר מותרים לשימוש בתנאי שהם עומדים בדרישות סעיף 4.3.3.',
        isTitle: false
      },
      {
        section: '4.3.11.5.6',
        title:
          'יש לסלק את חלקם הנגיש של החומרים הנטושים החשופים לזרם האוויר. כאשר מזוהים כבלים לשימוש עתידי באמצעות תג, התג יהיה בעל עמידות מספיקה כדי לעמוד בתנאי הסביבה המדוברת.',
        isTitle: false
      },
      {
        section: '4.3.11.6',
        title: 'גימור קירות או תקרות בתאי קיבול (פלנום)',
        isTitle: true
      },
      {
        section: '4.3.11.6.1',
        title:
          'גימור קירות או תקרות בתאי קיבול (פלנום), מלבד כמפורט בסעיף 4.3.11.6.2, יהיו לא בעירים או או יהיו בעלי סיווג אש שאינו קטן מ- Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.11.6.2',
        title:
          'חומר בידוד פלסטי מוקצף לא ישמש כגימור של קיר או תקרה בתאי קיבול (פלנום) אלא אם הבידוד עומד באחד הקריטריונים המובאים בסעיפים 4.3.11.6.2.1, 4.3.11.6.2.2, או 4.3.11.6.2.3.',
        isTitle: false
      },
      {
        section: '4.3.11.6.2.1',
        title:
          'חומר בידוד פלסטי מוקצף יהיו בעלי סיווג אש שאינו קטן מ- Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.11.6.2.2',
        title:
          'חומר בידוד פלסטי מוקצף יהיה מכוסה בפלדה עמידה בקורוזיה בעלת עובי מתכת בסיסי של לא פחות מ-0.4 מ"מ (0.0160 אינץ\') ויהיו בעלי סיווג אש שאינו קטן מ- Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.11.6.2.3',
        title:
          'חומר בידוד פלסטי מוקצף יהיה מופרד מתא קיבול (פלנום) באמצעות מחסום תרמי מאושר המורכב מלוחות גבס 12.7 מ"מ (0.5 אינץ\') או מחומר שנבדק הן בבדיקת אש להעברת טמפרטורה והן בבדיקת אש לשלמות על פי תקן NFPA 275, Standard Method of Fire Tests for the Evaluation of Thermal Barriers Used Over Foam Plastic Insulation, יהיו בעלי סיווג אש שאינו קטן מ- Class B ודרגת צפיפות עשן S1.',
        isTitle: false
      },
      {
        section: '4.3.12',
        title: 'מערכות אוויר במסדרונות',
        isTitle: true
      },
      {
        section: '4.3.12.1.1',
        title:
          'אסור על מסדרונות היציאה במוסדות בריאות וסיעוד, בבתי מעצר, במוסדות ענישה ובבתי מגורים לשמש כחלק מאספקה, מהחזרה או מפליטה של מערכת האוויר המשרתת אזורים סמוכים אלא אם הדבר מותר על פי האמור בסעיפים 4.3.12.1.3.1 עד 4.3.12.1.3.4.',
        isTitle: false
      },
      {
        section: '4.3.12.1.2',
        title:
          'תנועת אוויר בין חדרים ומסדרונות יציאה בבתי חולים ובמתקני טיפול אמבולטוריים מותרת כאשר מעבר האוויר נדרש למטרות רפואיות על פי תקנים אחרים.',
        isTitle: false
      },
      {
        section: '4.3.12.1.3',
        title:
          'אין להתיר פתחי מעבר אוויר בקירות או בדלתות המפרידים בין מסדרונות יציאה לאזורים הסמוכים.',
        isTitle: false
      },
      {
        section: '4.3.12.1.3.1',
        title:
          'פתחי מעבר אוויר הנפתחים ישירות למסדרון יציאה מותרים בקירות או בדלתות של שירותים, חדרי אמבטיה/מקלחות/כיורים וחללי עזר דומים.',
        isTitle: false
      },
      {
        section: '4.3.12.1.3.2',
        title:
          'כאשר מרווחי הדלתות אינם חורגים מאלה המוגדרים לדלתות אש על פי תקן ת"י 1212 - דלתות אש - עמידות באש, מותר מעבר האוויר הנגרם עקב הפרש הלחצים.',
        isTitle: false
      },
      {
        section: '4.3.12.1.3.3',
        title: 'מותר שימוש במסדרונות יציאה כחלק ממערכת בקרת עשן מתוכננת.',
        isTitle: false
      },
      {
        section: '4.3.12.1.3.4',
        title:
          'פתח(י) מעבר אוויר מותרים בקירות או בדלתות המפרידים בין מסדרונות היציאה לאזורים הסמוכים בבתי מעצר ובמוסדות ענישה, כאשר הפרדת מסדרונות אלה בנויה כמבנה פתוח (דוגמת דלתות או מחיצות בעלות סורגים).',
        isTitle: false
      },
      {
        section: '4.3.12.2',
        title:
          'יציאות\nאין להשתמש במעברי יציאה, בחדרי מדרגות, בכבשים וביציאות אחרות כחלק ממערכת הספקת/החזרת/פליטת אוויר המשרתת אזורים אחרים בבניין.',
        isTitle: false
      },
      {
        section: '4.3.13',
        title:
          'בקרת עשן\nכאשר נדרשת מערכת לבקרת עשן או מערכת פליטה, עליה לעמוד בדרישות חוקי הבנייה של הרשות המוסמכת.',
        isTitle: false
      }
    ]
  },
  {
    section: '5',
    title: 'שילוב מערכות אוורור ומיזוג אוויר במבנה הבניין',
    isTitle: true,
    subCases: [
      {
        section: '5.1',
        title: 'חדרי ציוד שינוע אוויר',
        isTitle: true
      },
      {
        section: '5.1.1',
        title:
          'כללי\nיש לסווג את חדרי הציוד שינוע אוויר לשלושה סוגים:\n(1)       אלה המשמשים כפלנומים לאוויר (בדרך כלל אוויר חוזר)\n(2)       אלה עם תעלות אוויר הנפתחות ישירות לפיר\n(3)       חדרים אחרים המאכלסים יחידת שינוע אוויר',
        isTitle: false
      },
      {
        section: '5.1.2',
        title:
          'חדרי ציוד שינוע אוויר המשמשים כחלל פלנום\nחדרי יחידות לשינוע אוויר המשמשים כתאי קיבול (פלנום) להספקת אוויר או להחזרתו חייבים לעמוד בדרישות סעיף 4.3.11.4.',
        isTitle: false
      },
      {
        section: '5.1.3',
        title:
          'חדרי ציוד שינוע אוויר המחוברים לתעלות אוויר הפתוחות ישירות לפיר.',
        isTitle: true
      },
      {
        section: '5.1.3.1',
        title:
          'חדרי ציוד לשינוע האוויר, כולל מיגון הפתחים, חייבים להיות מופרדים מן הפירים באמצעות מבנה בעל דרגת עמידות באש שאינה נמוכה מזו הנדרשת לפיר על פי סעיף 5.3.4.',
        isTitle: false
      },
      {
        section: '5.1.3.2',
        title:
          'הפרדה עמידה באש אינה נדרשת עבור חדרי ציוד שינוע אוויר המוקפים במבנה בעל דרגת עמידות באש שאינה נמוכה מזו הנדרשת לפיר.',
        isTitle: false
      },
      {
        section: '5.1.4',
        title:
          'חללים אחרים המאכלסים יחידות לשינוע אוויר\nחללים אחרים המאכלסים יחידות לשינוע אוויר חייבים לעמוד בתקנות הבניה של הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '5.2',
        title: 'בנייה',
        isTitle: true
      },
      {
        section: '5.2.2',
        title:
          'רכיבים מבניים\nאסור שהתקנת תעלות אוויר, כולל מתלים, תפגע בדרגת עמידות באש של הרכיבים המבניים.',
        isTitle: false
      },
      {
        section: '5.2.3',
        title:
          'מכללי תקרה\nכאשר התקנת המתלים לרכיבי מערכת תעלות האוויר חודרת דרך תקרה קיימת של מכלל רצפה-תקרה או גג-תקרה עמיד באש, ומחייבת הסרת חלק מתקרה זו, החומר המחליף חייב להיות זהה לזה שהוסר. לחלופין, עליו להיות מאושר כשקיל לחומר שהוסר.',
        isTitle: false
      },
      {
        section: '5.2.4',
        title:
          'כחלופה לתיקון התקרה הקיימת, מותר להתקין תקרה חדשה תחת מערכת תעלות האוויר, ובלבד שדרגת העמידות באש של תכנון הרצפה-תקרה או גג-תקרה לא תופחת.',
        isTitle: false
      },
      {
        section: '5.3',
        title: 'חדירות – מיגון פתחים.',
        isTitle: true
      },
      {
        section: '5.3.1.1',
        title:
          'מדפי אש המתאימים לתקן הישראלי ת"י 1001 חלק 3 יותקנו בפתחים שדרכם עובר מובל אוויר, בקיר אש במחיצת אש, כהגדרתם בתקנות התכנון והבנייה (בקשה להיתר, תנאיו ואגרות), התש"ל-1970, על עדכוניהן.',
        isTitle: false
      },
      {
        section: '5.3.1.1.1',
        title:
          'מדפי האש אינם נדרשים כאשר פתחים אחרים בקיר אינם מחייבים למיגון.',
        isTitle: false
      },
      {
        section: '5.3.2.1',
        title:
          'כאשר תעלות אוויר חודרות רק דרך רצפה אחת ומשרתות שתי קומות סמוכות זו לזו, יש להתקין עליהן מעטפת (ראה סעיף 5.3.4.1). לחלופין, יש להתקין מדפי אש בכל נקודה שבה קיימת חדירה דרך הרצפה.',
        isTitle: false
      },
      {
        section: '5.3.3.1',
        title:
          'כאשר תעלות אוויר ופתחיהן משמשים במכלל רצפה-תקרה או גג-תקרה הנדרש לדירוג עמידות באש, כל החומרים והמבנה של המכלל, כולל חומרי תעלות האוויר, ממדי הפתחים ומיגונם, חייבים לעמוד בדרישות התכנון של מכלל עמיד באש כפי שנבחן בהתאמה ל ת"י 931 חלק 1 (על חלקי המשנה שלו) - עמידות אש של אלמנטי בניין - שיטות בדיקה',
        isTitle: false
      },
      {
        section: '5.3.4',
        title: 'פירים',
        isTitle: true
      },
      {
        section: '5.3.4.1',
        title:
          'תעלות אוויר העוברות דרך רצפות בניינים הדורשות מיגון פתחים אנכיים חייבות במעטפת מחיצות או קירות הבנויים מחומרים המותרים על פי תקנות הבניה של הרשות המוסמכת, כפי שמצוין בסעיפים 5.3.4.2 או 5.3.4.3 אלא אם מעטפת כזה אינו נדרש על פי תנאי סעיף 5.3.4.3.1.',
        isTitle: false
      },
      {
        section: '5.3.4.2',
        title:
          'מעטפת הפיר חייב בדירוג עמידות באש מזערי (המבוסס על חשיפה אפשרית לאש משני צדי המחיצה או הקיר) של שעה אחת כאשר תעלות אוויר כאלה ממוקמות בבניין שגובהו פחות מארבע קומות.',
        isTitle: false
      },
      {
        section: '5.3.4.3',
        title:
          'מעטפת הפיר חייב בדירוג עמידות באש מזערי (המבוסס על חשיפה אפשרית לאש משני צדי המחיצה או הקיר) של שעתיים כאשר תעלות אוויר כאלה ממוקמות בבניין שגובהו ארבע קומות, או יותר.',
        isTitle: false
      },
      {
        section: '5.3.4.3.1',
        title:
          'כאשר תעלת האוויר חודרת דרך רצפה אחת בלבד, או דרך רצפה אחת ורצפה של דירת גג שעליה ממוקם ציוד שינוע האוויר, ותעלת אוויר זו מצוידת במדף אש במקום שבו היא חודרת דרך הרצפה, המעטפת לתעלת האוויר אינו נדרש.',
        isTitle: false
      },
      {
        section: '5.3.4.4',
        title:
          'מעטפת עמיד באש המשמש כתעלת אוויר חייב לעמוד בהוראות סעיף 4.3.1 ובהוראות סעיפים 5.3.4.2 עד 5.3.4.3.1.',
        isTitle: false
      },
      {
        section: '5.3.4.4.1',
        title:
          'מערכות עשויות לוחות גבס ייבנו לפי הוראות יצרן לוחות הגבס. ביצוע העבודה יהיה בהתאם לתעודות הבדיקה ולהנחיות היצרן בהתאם לת"י 1924.',
        isTitle: false
      },
      {
        section: '5.3.4.5',
        title:
          'פירים המשמשים תעלות אוויר שמעבירות אוויר סביבתי או כאלה המשמשים כיסוי לתעלות כאלה, אסור שישמשו כיסוי למתקנים הבאים:\n(1)  תעלות פליטה המשמשות להרחקת עשן ואדי שומנים מציוד בישול\n(2)  תעלות המשמשות להרחקת אדים דליקים\n(3)  תעלות המשמשות לתנועה, להעברה או להובלה של סחורות, אדים או אבק\n(4)  עלות המשמשות להרחקת עשן ואדים קורוסיביים לא דליקים\n(5)  תעלות לפינוי פסולת ולבנים\n(6)  צנרת, למעט צנרת לא בעירה להולכת מים או חומרים לא מסוכנים ולא רעילים אחרים\n(7)  אחסון של חומרים בעירים',
        isTitle: false
      },
      {
        section: '5.3.4.6',
        title:
          'יש להתקין מדפי אש בכל פתח ישיר או מתועל המוליך לתוך המעטים הנדרשים על פי סעיף 5.3.4.1, או מהם אלא אם סעיפים 5.3.4.6.1 או 5.3.4.6.2 פוטרים מדרישה זו.',
        isTitle: false
      },
      {
        section: '5.3.4.6.1',
        title:
          'מדף אש אינו נדרש כאשר מערכת תעלות אוויר המשרתת קומה אחת בלבד משמשת לפליטת אוויר החוצה ומוכלת בתוך פיר ייעודי משלה.',
        isTitle: false
      },
      {
        section: '5.3.4.6.2',
        title:
          'מדף אש אינו נדרש כאשר מתמלאים כל התנאים הבאים:\n(1) שלוחות של תעלות מתחברות לתעלות פליטה אנכיות העומדות בדרישות סעיפים 5.3.4.1 או 5.3.4.4.\n(2) האוויר זורם מעלה.\n(3) מכל כניסה בתוך התעלות האנכיות מובילות מעלה תעלות משנה מפלדה באורך 560 מ"מ (22 אינץ\') לפחות.\n(4) בממדי התעלה האנכית יש כדי לפצות על מגבלות הזרימה הנוצרות על ידי תעלות המשנה הפנימיות.\nהכתוב בסעיף זה חל על התכנון העקרוני בתפעול השוטף של המערכת ולא במצב של שריפה.',
        isTitle: false
      },
      {
        section: '5.3.5',
        title: 'מחסומי עשן',
        isTitle: true
      },
      {
        section: '5.3.5.1',
        title:
          'יש להתקין מדפי עשן בנקודה שבה תעלות האוויר עוברות דרך מחסומי עשן נדרשים, או בסמוך לה, ובשום מקרה אין להתקין את מדפי העשן במרחק שמעל 0.6 מטר מהמחסום, או אחרי הכניסה או היציאה הראשונה של תעלת האוויר, הקרובה למחסום העשן מבין השתיים אלא אם סעיפים 5.3.5.1.1 עד 5.3.5.1.5 מתירים סטייה מדרישה זו.',
        isTitle: false
      },
      {
        section: '5.3.5.1.1',
        title:
          'אין דרישה למדפי עשן במערכות אוויר, אלא כשהם נחוצים לפעולה תקינה של המערכת במקום שהיא מתוכננת במיוחד כדי להשיג:\n(1) לפעול כמערכת בקרת עשן מתוכננת, כולל הספקת תנועת אוויר רציפה במערכת שינוע האוויר\n(2) לספק אוויר לאזורים אחרים בבניין בשעת חירום אש\n(3) לספק הפרש לחצים בשעת חירום אש',
        isTitle: false
      },
      {
        section: '5.3.5.1.2',
        title:
          'אין דרישה למקם את מדפי העשן בתוך המרחק הנקוב ממחסום עשן כאשר מדפי עשן מבודדים, העומדים בדרישות סעיף 4.3.9.2, משמשים בציוד לשינוע האוויר.',
        isTitle: false
      },
      {
        section: '5.3.5.1.3',
        title:
          'מדפי העשן אינם נדרשים כאשר פתחי כניסת/יציאת האוויר בתעלות האוויר מוגבלים לתא עשן יחיד.',
        isTitle: false
      },
      {
        section: '5.3.5.1.4',
        title:
          'אין דרישה למדפי עשן בתעלות אוויר שבהן האוויר מוסיף לנוע ומערכת שינוע האוויר מונעת מחזור האוויר הנפלט או המוחזר בתנאי חירום אש.',
        isTitle: false
      },
      {
        section: '5.3.5.2',
        title:
          'כאשר חדירה דרך מחסום עשן נדרשת להתקנת מדף אש, מותר להתקין מדף עשן-אש משולב המגיב לעשן ולחום גם יחד.',
        isTitle: false
      },
      {
        section: '5.4',
        title: 'מדפי אש, מדפי עשן ומדפי תקרה',
        isTitle: true
      },
      {
        section: '5.4.1',
        title: 'מדפי אש',
        isTitle: true
      },
      {
        section: '5.4.1.1',
        title:
          'מדפי אש המשמשים למיגון פתחים בקירות, במחיצות או ברצפות בעלי דירוג עמידות באש של פחות מ-3 שעות חייבים בדירוג הגנה מפני אש של 1.5 שעות על פי תקן ת"י 1001 חלק 3 - בטיחות אש בבניינים: מדפי אש.',
        isTitle: false
      },
      {
        section: '5.4.1.2',
        title:
          'מדפי האש יהיו ממונעים. למרות האמור לעיל, התקנת מדפי אש לא ממונעים מותרת רק במקומות המפורטים להלן:\nא. במקום החיבור של מובל אופקי להולכת אוויר נפלט מחדרי שירותים למובל אנכי;\nב. במקום החיבור של מובל אוויר חיצוני ליחידת קצה;\nג. במקום החדירה של מובל דרך גג.',
        isTitle: false
      },
      {
        section: '5.4.2',
        title:
          'מדפי אש המשמשים למיגון פתחים בקירות, במחיצות או ברצפות בעלי דירוג עמידות באש של 3 שעות או יותר חייבים בדירוג הגנה מפני אש של 3 שעות על פי תקן ת"י 1001 חלק 3 - בטיחות אש בבניינים: מדפי אש.',
        isTitle: false
      },
      {
        section: '5.4.3',
        title: 'מדפי עשן',
        isTitle: true
      },
      {
        section: '5.4.3.1',
        title:
          'דירוג הדליפה של מדפי העשן יהיה לפחות סוג II, ודירוג עליית הטמפרטורה יהיה לא פחות מ-121°C.',
        isTitle: false
      },
      {
        section: '5.4.4',
        title: 'מדפי תקרה',
        isTitle: true
      },
      {
        section: '5.4.4.1',
        title:
          'מדפי תקרה או שיטות אחרות של מיגון פתחים במכללי רצפה-תקרה או גג-תקרה מדורגים חייבים לעמוד בפרטי הבנייה החלים על מכלל הרצפה-תקרה או הגג-תקרה הנבדק, או של מפזרי אוויר בתקרה מפורטים, או של מדפי תקרה מפורטים.',
        isTitle: false
      },
      {
        section: '5.4.4.2',
        title:
          'יש לבדוק את מדפי התקרה על פי ת"י 1001 חלק 3 - בטיחות אש בבניינים: מדפי אש.',
        isTitle: false
      },
      {
        section: '5.4.5',
        title: 'סגירת מדפים (Dumper)',
        isTitle: true
      },
      {
        section: '5.4.5.1',
        title: 'כל מדפי האש ומדפי התקרה חייבים להיסגר באופן אוטומטי.',
        isTitle: false
      },
      {
        section: '5.4.5.1.1',
        title:
          'כל מדפי האש ומדפי התקרה חייבים להישאר סגורים אחרי הפעלתם באמצעות חיבור נתיך מפורט או באמצעות התקן מופעל-חום אחר המוצב במקום המושפע מיד מעליה חריגה בטמפרטורה.',
        isTitle: false
      },
      {
        section: '5.4.5.2.1',
        title:
          'חיבורים נתיכים חייבים להיות בעלי דירוג לטמפרטורה הגבוהה בכ-28ºC (50ºF) מן הטמפרטורה המרבית השוררת כרגיל במערכת כאשר היא בפעולה או מושבתת.',
        isTitle: false
      },
      {
        section: '5.4.5.2.2',
        title:
          'דירוג טמפרטורת החיבורים הנתיכים חייב להיות לא פחות מ-71°C (160°F).',
        isTitle: false
      },
      {
        section: '5.4.5.2.2.1',
        title:
          'כאשר מדפי האש-עשן המשולבים מותקנים בתוך תעלות אוויר שהן חלק ממערכת בקרת עשן מתוכננת, חיבורים נתיכים או התקנים מאושרים אחרים המגיבים לחום, הם חייבים בדירוג טמפרטורה הגבוה בכ-28ºC  מטמפרטורת ההפעלה המתוכננת המרבית של מערכת בקרת העשן.',
        isTitle: false
      },
      {
        section: '5.4.5.2.2.2',
        title:
          'אסור שמדפי האש-עשן המשולבים יחרגו מדירוג טמפרטורת בדיקת ההגרעה על פי תקן ת"י 1001 חלק 4 - בטיחות אש בבניינים: מדפי עשן.',
        isTitle: false
      },
      {
        section: '5.4.5.2.2.3',
        title:
          'אסור שמדפי האש-עשן המשולבים יחרגו מדירוג טמפרטורה מרבי של 177°C.',
        isTitle: false
      },
      {
        section: '5.4.5.3',
        title:
          'מותרת התקנת פתח מרוחק עבור מדפי אש-עשן משולבים כאשר הדבר נדרש לפינוי העשן.',
        isTitle: false
      },
      {
        section: '5.4.5.3.1',
        title:
          'מדפי האש-עשן המשולבים המותרים על פי סעיף 5.4.5.3 חייבים באמצעי שיאפשר לסגור אותם אוטומטית מחדש כשהם מגיעים לטמפרטורת בדיקת ההגרעה המרבית על פי תקן ת"י 1001 חלק 4 - בטיחות אש בבניינים: מדפי עשן.',
        isTitle: false
      },
      {
        section: '5.4.5.4',
        title:
          'על המדפים (Dumper) להיסגר כנגד זרם האוויר המחושב המרבי השורר באותו קטע של מערכת תעלות האוויר שבו הם מותקנים.',
        isTitle: false
      },
      {
        section: '5.4.5.4.3',
        title:
          'מדפי אש, מדפי עשן ומדפי אש-עשן לא יידרשו בתעלות המשמשות במערכות יניקת אוויר ממטבחים או מייבשי כביסה.',
        isTitle: false
      },
      {
        section: '5.4.6',
        title: 'פרטי מיקום המדפים (Dumper)',
        isTitle: true
      },
      {
        section: '5.4.6.1',
        title:
          'יש להציג על גבי שרטוט מערכת תעלות האוויר את מיקומם ואת סדרי ההתקנה של כל מדפי האש, מדפי העשן, מדפי התקרה, ושל האמצעים הדומים למיגון מפני אש הנדרשים בתקן זה.',
        isTitle: false
      },
      {
        section: '5.4.6.2',
        title:
          'זרם האוויר המחושב יוצג במיקומם של המדפים (Dumper) הנדרשים להיסגר כנגד זרם האוויר על גבי שרטוט מערכת תעלות האוויר.',
        isTitle: false
      },
      {
        section: '5.4.7',
        title: 'התקנה.',
        isTitle: true
      },
      {
        section: '5.4.7.1',
        title:
          'יש להתקין את מדפי האש, על שרווליהם, את מדפי העשן ואת מדפי התקרה בהתאם לתנאי הרישום שלהם, להוראות היצרן ולדרישות תקן ת"י 1212 - דלתות אש - עמידות באש.',
        isTitle: false
      },
      {
        section: '5.4.7.2',
        title:
          'יש להתקין את מדפי העשן בהתאם לתנאי הרישום שלהם, להוראות היצרן ולדרישות תקן ת"י 1212 חלק 3 - מכללי דלתות אש ומכללי דלתות עשן: דלתות עשן.',
        isTitle: false
      }
    ]
  },
  {
    section: '6',
    title: 'אמצעי בקרה',
    isTitle: true,
    subCases: [
      {
        section: '6.2',
        title: 'בקרה ידנית',
        isTitle: true
      },
      {
        section: '6.2.1',
        title:
          'כל מערכת חלוקת אוויר חייבת להיות מצוידת באמצעי ידני אחד לפחות להפסקת הפעולה בחירום, של מאווררי האספקה, ההחזרה והפליטה.',
        isTitle: false
      },
      {
        section: '6.2.2',
        title: 'האמצעי להפעלה הידנית חייב להיות ממוקם במקום מאושר.',
        isTitle: false
      },
      {
        section: '6.3',
        title: 'מדפי עשן',
        isTitle: true
      },
      {
        section: '6.3.1',
        title:
          'פעולתם של מדפי העשן חייבת להיות מבוקרת באמצעות התקן אוטומטי המופעל על ידי אזעקה.',
        isTitle: false
      },
      {
        section: '6.3.2',
        title: 'מותרת גם שליטה ידנית על מצבם של מדפי העשן באמצעות תחנת פיקוד.',
        isTitle: false
      },
      {
        section: '6.3.3',
        title:
          'מדפי העשן, המותקנים כדי לבודד את מערכת שינוע האוויר על פי האמור בסעיף 4.3.9.2, חייבים להיסגר באופן אוטומטי כאשר המערכת אינה בפעולה.',
        isTitle: false
      },
      {
        section: '6.3.4',
        title:
          'מדפי העשן יכולים להישאר פתוחים בעת הפסקת פעולתם של המאווררים, ובלבד שאמצעי ההפעלה והבקרה שלהם וההתקנים האוטומטיים המופעלים על ידי אזעקה נותרים פעילים.',
        isTitle: false
      },
      {
        section: '6.4',
        title: 'גילוי עשן לבקרה אוטומטית',
        isTitle: true
      },
      {
        section: '6.4.2.1',
        title:
          'גלאי העשן המפורטים לשימוש במערכות חלוקת האוויר יהיו ממוקמים כמפורט להלן:\n(1) אחרי מסנני האוויר ולפני חיבורי השלוחות במערכת הספקת אוויר בעלת תפוקה העולה על 2,000 CFM\n(2) בכל קומה לפני החיבור להחזרה משותפת ולפני מחזור כלשהו, או חיבור כניסת אוויר טרי, במערכות החזרת אוויר בעלות תפוקה העולה על 15,000 CFM המשרתות יותר מקומה אחת',
        isTitle: false
      },
      {
        section: '6.4.2.2',
        title:
          'גלאי האש במערכת ההחזרה אינם נדרשים כאשר החלל כולו, הנהנה משירות מערכת חלוקת האוויר, מוגן באמצעות מערכת גלאי עשן בשטח.',
        isTitle: false
      },
      {
        section: '6.4.2.3',
        title:
          'גלאי העשן אינם נדרשים ליחידות מאוורר שפעולתם היחידה היא פינוי האוויר מתוך הבניין אל מחוצה לו.',
        isTitle: false
      },
      {
        section: '6.4.3.1',
        title:
          'מיד עם גילוי נוכחות עשן, על גלאי העשן המותקנים על פי דרישת סעיף 6.4.2 להפסיק אוטומטית את פעולת המאווררים שלהם.',
        isTitle: false
      },
      {
        section: '6.4.3.2',
        title:
          'כאשר מאוורר להחזרת האוויר פועל כחלק ממערכת בקרת עשן מתוכננת ונדרש מצב פעולה שונה, אין נדרשים גלאי העשן להפסיק אוטומטית את פעולת המאווררים שלהם.',
        isTitle: false
      },
      {
        section: '6.4.4.2',
        title:
          'בנוסף לדרישות סעיף 6.4.3, כאשר מותקנת מערכת אזעקת אש מאושרת בבניין, על גלאי העשן הנדרשים על פי הוראות סעיף 6.4 להיות מחוברים למערכת אזעקת האש בהתאם לדרישות תקן ת"י 1220 על חלקיו - מערכות גילוי  אש.',
        isTitle: false
      }
    ]
  },
  {
    section: '7',
    title: 'בדיקת קבלה',
    isTitle: true,
    subCases: [
      {
        section: '7.1.1',
        title:
          'יש לבצע בדיקת קבלה כדי לוודא כי אמצעי המיגון הנדרשים בתקן זה פועלים באופן תקין כאשר הם נדרשים להגביל את התפשטות האש והעשן. \nוכן ע"פ משטר הפעלות מערכות בטיחות אש הוראת מכ"ר 536',
        isTitle: false
      },
      {
        section: '7.2',
        title:
          'מדפי אש, מדפי עשן ומדפי תקרה\nיש להפעיל את כל מדפי האש, מדפי העשן ומדפי התקרה לפני אכלוס הבניין כדי לוודא כי הם פועלים על פי דרישות תקן זה.\nוכן ע"פ משטר הפעלות מערכות בטיחות אש הוראת מכ"ר 536',
        isTitle: false
      },
      {
        section: '7.3.2',
        title:
          'יש לבצע את בדיקות הקבלה להתקני מיגון מפני אש, במערכות מיזוג האוויר והאוורור, בתנאי הפעלה רגילים ככל האפשר.\nוכן ע"פ משטר הפעלות מערכות בטיחות אש הוראת מכ"ר 536',
        isTitle: false
      },
      {
        section: '7.3.3',
        title:
          'חלקן של מערכות הבקרה או האזעקה מותרים להפעלה באמצעות הספקת כוח בכוננות או בשיטות הפעלת חירום אחרות.\nוכן ע"פ משטר הפעלות מערכות בטיחות אש הוראת מכ"ר 536',
        isTitle: false
      },
      {
        section: '7.3.4',
        title:
          'יש לבצע בדיקה כדי לוודא כי המערכת פועלת באמצעות הספקת הכוח בכוננות או בשיטות הפעלת החירום האחרות באופן תקין כפי שהיא פועלת בתנאים רגילים.\nוכן ע"פ משטר הפעלות מערכות בטיחות אש הוראת מכ"ר 536',
        isTitle: false
      }
    ]
  }
];
